import { render, staticRenderFns } from "./Finantial.vue?vue&type=template&id=d6742068&scoped=true&"
import script from "./Finantial.vue?vue&type=script&lang=js&"
export * from "./Finantial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6742068",
  null
  
)

export default component.exports